import * as React from 'react'
import * as NavigationMenuPrimitive from '@radix-ui/react-navigation-menu'

import { cn } from '@/utilities/ui'

export function NavigationMenu({
  className,
  children,
  ...props
}: React.ComponentProps<typeof NavigationMenuPrimitive.Root>) {
  return (
    <NavigationMenuPrimitive.Root
      data-slot="navigation-menu"
      className={cn(
        'group/navigation-menu relative flex flex-1 items-center justify-center',
        className,
      )}
      {...props}
    >
      {children}
    </NavigationMenuPrimitive.Root>
  )
}

export function NavigationMenuList({
  className,
  ...props
}: React.ComponentProps<typeof NavigationMenuPrimitive.List>) {
  return (
    <NavigationMenuPrimitive.List
      data-slot="navigation-menu-list"
      className={cn(
        'group flex flex-1 list-none items-center justify-center gap-[10px]',
        className,
      )}
      {...props}
    />
  )
}

export function NavigationMenuItem({
  className,
  ...props
}: React.ComponentProps<typeof NavigationMenuPrimitive.Item>) {
  return (
    <NavigationMenuPrimitive.Item
      data-slot="navigation-menu-item"
      className={cn('relative', className)}
      {...props}
    />
  )
}

export function NavigationMenuTrigger({
  children,
  ...props
}: React.ComponentProps<typeof NavigationMenuPrimitive.Trigger>) {
  return (
    <NavigationMenuPrimitive.Trigger asChild data-slot="navigation-menu-trigger" {...props}>
      {children}
    </NavigationMenuPrimitive.Trigger>
  )
}

export function NavigationMenuContent({
  className,
  ...props
}: React.ComponentProps<typeof NavigationMenuPrimitive.Content>) {
  return (
    <NavigationMenuPrimitive.Content
      data-slot="navigation-menu-content"
      className={cn(
        'top-0 left-0 w-full p-2 pr-2.5 md:absolute md:w-auto',
        'data-[motion^=from-]:animate-in data-[motion^=to-]:animate-out',
        'data-[motion^=from-]:fade-in data-[motion^=to-]:fade-out',
        'data-[motion=from-end]:slide-in-from-left-5',
        'data-[motion=from-start]:slide-in-from-right-5',
        'data-[motion=to-end]:slide-out-to-left-2',
        'data-[motion=to-start]:slide-out-to-right-2',
        'bg-rock-2',
        'text-popover-foreground',
        'data-[state=open]:animate-in',
        'data-[state=closed]:animate-out',
        'data-[state=closed]:zoom-out-69',
        'data-[state=open]:zoom-in-69',
        'data-[state=open]:fade-in-0',
        'data-[state=closed]:fade-out-0',
        'top-full',
        'mt-[16px]',
        'overflow-hidden',
        'rounded-md',
        'shadow',
        'duration-200',
        '**:data-[slot=navigation-menu-link]:focus:ring-0',
        '**:data-[slot=navigation-menu-link]:focus:outline-none',
        className,
      )}
      {...props}
    />
  )
}

export function NavigationMenuLink({
  ...props
}: React.ComponentProps<typeof NavigationMenuPrimitive.Link>) {
  return <NavigationMenuPrimitive.Link data-slot="navigation-menu-link" {...props} />
}
